export const UPDATE_HEADER = /* GraphQL */ `
  mutation updateHeaderMutation($input: HeaderInput!) {
    updateHeader(input: $input) {
      id
      title
      description
      video
      image
      btnLabel
      btnUrl
      createdAt
      updatedAt
    }
  }
`;